module.exports = __webpack_public_path__ + "img/santos-negotiation.90c28794.png";